
import { DEFAULT_KONVA_SCALE, DEFAULT_KONVA_STAGE_POSITION, IMAGERY_PROVIDER } from '../../../constants';
import { ToolHistory, ToolNewPostionSilce } from './types';

const initializeState = ()=>({
	roofIndexes: [],
	selectedRoofIndex: null,
	selectedRoofAzimuth: null,
	deletedRoofIndexes: [],
	newlyCreatedFacets: {},
	editModeEnabled: false,
	threeDModelEnabled: false,
	saveWithPanelColor: false,
	userHasClickedSave: false,
	drawModeEnabled: false,
	isMouseOnMap: false,
	selectedUnfinalizedKonvaFacetId: null,
	deleteUnfinalizedFacet: false,
	zoomLevel: DEFAULT_KONVA_SCALE,
	moveStage: false,
	rotateStage: false,
	stageRotation: 0,
	konvaStagePosition: DEFAULT_KONVA_STAGE_POSITION,
	userHasModifiedRoofSegs: false,
	fullScreenEnabled: false,
	selectedProvider: IMAGERY_PROVIDER.SUNROOF,
	hadTransition: false,
	deletedObstructionIDs: [],
	deleteObstructionsMode: false,
	currentActiveFacetEditMode: undefined,
	facetHistory: initialFacetHistory,
	deleteObstructionsPopUp: false,
	toggleGroundMountEnabled: false,
	groundMountEnabled: false,
	editShadingPerformed: false,
	toggleNoGapGroundMountEnabled: false,
	noGapGroundMountEnabled: false,
	enabledDevMode: false,
	azimuthEditedFacets: {},
	invalidAzimuthFacets: {},
	confirmedExceedingAzimuthFacets: [],
	anyInvalidAzimuth: false,
	addObstructionsMode: false,
	addObstructionsPopUp: false,
	obstructionShape: 'RECT' as ToolNewPostionSilce['obstructionShape'],
	manualObs: {},
	showSetback: false,
	fullModePopupOpen: false,
	fullModePopupMessgage: '',
	showLinearFtForSolar: false,
	deleteFacetMode: false,
	multiFingersPress: false,
	fullViewSidePanel: false,
	fullViewSidePanelBeforeThreeD: null,
	threeDViewLoaded: false,
	isCancelModalOpen: false,
	drawnFacetExists: false,
	enableEditObs: false,
	editedObstructions: {},
	invalidObstructionIds: [],
	drawnObsExists: false,
	selectedObstructionId: null,
	obstructionEditPointAction: null,
	isTransformingAzimuth: false,
	pendingAzimuthConfirmationFacet: null,
	guideMode: false,
	snapMode: false,
	hideSatelliteOverlay: false,
	activeDragFunctionality: null,
	mapOnlyFrozenPoint: null,
});

const initialFacetHistory: ToolNewPostionSilce['facetHistory'] = {
	obstruction: {
		currentIndex: -1,
		history: [],
	},
	deleteFacet: {
		currentIndex: -1,
		history: [],
	},
};

function updateFacetHistory<T>(history: ToolHistory<T>, newState: T): ToolHistory<T> {
	history.history = [
		...history.history.slice(0, history.currentIndex + 1),
		newState,
	];
	history.currentIndex = history.history.length - 1;
	return history;
}

export {
	initializeState,
	updateFacetHistory,
};
